<script>
export default {
  name: "index.vue",
  data() {
    return {

    }
  },
  methods: {
    jumpToPortal() {
      const url = encodeURIComponent(`${window.location.origin}/#${this.$store.state.preUrl}`)
      // 重定向到上次访问的地址上
      window.location.href = `${process.env.VUE_APP_PORTAL_URL}?redirect_url=${url}`;
    }
  }
}
</script>

<template>
  <div class="no-permission">
    <img src="@/assets/images/401.png" alt="401，无权限" />
    <div class="permission-title">无访问权限</div>
    <div class="permission-desc">
      抱歉，您当前无法访问此页面可能是因为您尚未登录或者账户权限不足。
      <a class="login-btn" @click="jumpToPortal">请登录</a>
    </div>
  </div>
</template>

<style scoped lang="scss">
.no-permission {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  .permission-title {
    font-size: 18px;
    margin-top: 32px;
    font-weight: 500;
  }
  .permission-desc {
    font-size: 14px;
    margin-top: 10px;
  }
  .login-btn {
    color: #005EBA;
  }
}
</style>
